<template>
  <div id="wrapper">
    <div class="homePage-1"></div>
    <div class="homePage-2"></div>
  </div>
</template>

<script>
    export default {
      name: "index",
      data() {
        return {
        }
      },
      methods: {

      },
      mounted() {

      }
    }
</script>

<style scoped>
  .homePage-1{
    position: relative;
    max-height: 54.5rem;
    padding-top: 45%;
    background: url("../../static/images/home/homePage-1.png") no-repeat center / cover;
  }

  .homePage-2{
    position: relative;
    max-height: 45.44rem;
    padding-top: 38%;
    background: url("../../static/images/home/homePage-2.png") no-repeat center / cover;
  }

  @media (max-width: 768px) {
    .homePage-1{
      position: relative;
      max-height: 105.68rem;
      padding-top: 225%;
      margin: 5rem auto;
      background: url("../../static/images/home/homePageH5-1.png") no-repeat center / cover;
    }

    .homePage-2{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue